(function () {
  'use strict';

  if (customElements.get('related-products')) return;

  customElements.define('related-products', class RelatedProducts extends HTMLElement {
    constructor() {
      super();
      this.hasLoaded = false;
      this.observer = null;
    }

    connectedCallback() {
      if (this.hasLoaded) return;

      this.dataset.lazyActive = 'false';

      if (window.Shopify && window.Shopify.designMode) {
        this.activate();
        return;
      }

      if (!('IntersectionObserver' in window)) {
        this.activate();
        return;
      }

      this.observer = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        this.activate();
      }, {
        rootMargin: '900px 0px',
        threshold: 0.01
      });

      this.observer.observe(this);
    }

    activate() {
      if (this.hasLoaded) return;

      this.hasLoaded = true;
      this.dataset.lazyActive = 'true';

      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }

      this.dispatchEvent(new CustomEvent('theme:related-products:activate', {
        bubbles: false
      }));

      this.loadRelatedProducts();
      this.loadRecentlyViewedProducts();
    }

    loadRelatedProducts() {
      this.relatedProducts = this.querySelector('[data-related-products]');
      if (!this.relatedProducts) return;

      const sectionId = this.getAttribute('data-section-id');
      const productId = this.getAttribute('data-product-id');
      const limit = this.getAttribute('data-limit');
      const url = `${theme.routes.product_recommendations_url}?section_id=${sectionId}&limit=${limit}&product_id=${productId}`;

      fetch(url)
        .then((response) => {
          if (!response.ok) {
            const error = new Error(response.status);
            this.hideRelated();
            throw error;
          }

          return response.text();
        })
        .then((text) => {
          const container = document.createElement('div');
          container.innerHTML = text;

          const relatedProducts = container.querySelector('[data-related-products]');
          if (relatedProducts && relatedProducts.querySelectorAll('[data-product-block]').length) {
            this.relatedProducts.innerHTML = relatedProducts.innerHTML;
          }
        })
        .catch(() => {});
    }

    loadRecentlyViewedProducts() {
      this.recentlyViewed = this.querySelector('recently-viewed');
      if (!this.recentlyViewed) return;

      this.recentlyViewed.addEventListener('theme:recently-viewed:loaded', () => {
        this.handleRecentlyViewedResponse();
      });
    }

    handleRecentlyViewedResponse() {
      const wrapper = this.recentlyViewed.closest('[data-recently-viewed-wrapper]');
      const productBlocks = this.recentlyViewed.querySelectorAll('[data-product-block]');
      const animatedItems = this.recentlyViewed.querySelectorAll('[data-aos]');
      const slider = this.recentlyViewed.querySelector('grid-slider');
      const minimum = this.recentlyViewed.hasAttribute('data-minimum')
        ? parseInt(this.recentlyViewed.getAttribute('data-minimum'))
        : 1;
      const hasProductsWithoutWrapper = !wrapper && productBlocks.length > 0;
      const hasEnoughProducts = wrapper && productBlocks.length >= minimum;
      const columnsMobile = slider?.getAttribute('data-column-mobile');

      if (!hasProductsWithoutWrapper && !hasEnoughProducts) return;

      if (hasEnoughProducts) this.classList.remove('hidden');

      if (slider) {
        requestAnimationFrame(() => {
          slider.dispatchEvent(new CustomEvent('theme:slider:resize', { bubbles: true }));
        });

        slider.querySelectorAll('[data-slide]').forEach((slide) => {
          if (columnsMobile == 2) {
            slide.classList.add('mobile--one-half');
            slide.classList.remove('mobile--one-whole');
          } else {
            slide.classList.add('mobile--one-whole');
            slide.classList.remove('mobile--one-half');
          }
        });
      }

      const animatedTargets = [];
      this.recentlyViewed.addEventListener('theme:target:animate', (event) => {
        animatedTargets.push(event.detail);

        if (animatedTargets.length === animatedItems.length) {
          requestAnimationFrame(() => animatedItems.forEach((item) => item.classList.add('aos-animate')));
        }
      });
    }

    hideRelated() {
      const tab = this.relatedProducts.closest('[data-tab]');
      const tabsHolder = this.relatedProducts.closest('[data-tabs-holder]');
      const tabsLink = tabsHolder?.querySelector(`[data-tabs-link="${tab.dataset.tab}"]`);

      tab?.remove();

      if (tabsLink) {
        tabsLink.remove();
        tabsHolder.querySelector('[data-tabs-link]')?.dispatchEvent(new Event('click'));
      }
    }
  });
})();
